const topicItems = [
  { id: 'topic-1', label: '#最新电影推荐', heat: '热门', count: '2.8万讨论' },
  { id: 'topic-2', label: '#蓝光画质体验', heat: '新晋', count: '1.5万讨论' },
  { id: 'topic-3', label: '#周末追剧清单', heat: '热门', count: '3.2万讨论' },
  { id: 'topic-4', label: '#经典老片回顾', heat: '热门', count: '2.1万讨论' },
  { id: 'topic-5', label: '#国产剧崛起', heat: '热门', count: '4.6万讨论' },
  { id: 'topic-6', label: '#手机观影技巧', heat: '新晋', count: '0.9万讨论' },
  { id: 'topic-7', label: '#深夜电影推荐', heat: '热门', count: '1.8万讨论' },
  { id: 'topic-8', label: '#不缓冲看片', heat: '持续', count: '2.3万讨论' },
  { id: 'topic-9', label: '#综艺下饭必备', heat: '热门', count: '3.5万讨论' },
];

const rankingItems = [
  { id: 'rank-1', rank: 1, title: '无名之火', type: '电影 / 悬疑', hot: '本周热度飙升', trend: 'up', change: '+12' },
  { id: 'rank-2', rank: 2, title: '春风十里', type: '电视剧 / 都市', hot: '连续三周霸榜', trend: 'stay', change: '0' },
  { id: 'rank-3', rank: 3, title: '深海追凶', type: '电影 / 犯罪', hot: '新上榜', trend: 'up', change: '+28' },
  { id: 'rank-4', rank: 4, title: '极光之夜', type: '电视剧 / 爱情', hot: '口碑发酵中', trend: 'up', change: '+8' },
  { id: 'rank-5', rank: 5, title: '荒野求生实录', type: '综艺 / 冒险', hot: '持续热门', trend: 'stay', change: '-1' },
  { id: 'rank-6', rank: 6, title: '时光回响', type: '电影 / 文艺', hot: '新晋入榜', trend: 'up', change: '+15' },
];

const featureItems = [
  {
    id: 'feat-1',
    title: '蓝光画质',
    desc: '全站支持1080P蓝光超清画质，画面清晰细腻、色彩还原真实。智能码率自适应技术，根据网络环境动态调节画质，即使在弱网环境下也能保障清晰流畅的观影体验。',
    icon: 'ri-4k-line',
  },
  {
    id: 'feat-2',
    title: '流畅播放',
    desc: '多线路智能切换与CDN加速技术确保播放不缓冲、不卡顿。独家播放引擎优化加载速度，打开即播无缝切换。无论早晚高峰时段均可保持稳定流畅的播放状态。',
    icon: 'ri-speed-up-line',
  },
  {
    id: 'feat-3',
    title: '免费观影',
    desc: '春夜影院始终坚持免费提供全站影视内容，无需付费或订阅。电影电视剧综艺动漫全面覆盖，每日更新海量资源。电脑手机平板全端通用，随时随地免费畅享光影世界。',
    icon: 'ri-gift-line',
  },
];

export default function SectionsC() {
  return (
    <>
      {/* #topics - 9 topic tags */}
      <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-100 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">
              话题广场
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              大家都在讨论的影视热点话题，参与讨论分享你的观影观点
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3">
            {topicItems.map((item) => (
              <div
                key={item.id}
                className="group flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 cursor-pointer transition-all duration-200"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors duration-200 whitespace-nowrap">
                  {item.label}
                </span>
                <span className={`text-[10px] px-1.5 py-0.5 rounded whitespace-nowrap ${
                  item.heat === '热门' ? 'bg-accent-100 text-accent-700' :
                  item.heat === '新晋' ? 'bg-secondary-100 text-secondary-700' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.heat}
                </span>
                <span className="text-[10px] text-foreground-400 whitespace-nowrap">{item.count}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #ranking - 6 ranking items */}
      <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
              实时榜单
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              热播榜单
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              基于观看热度和用户讨论综合排名的实时影视榜单
            </p>
          </div>

          <div className="max-w-2xl mx-auto bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.id}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-50 transition-colors duration-200 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                }`}
              >
                {/* Rank number */}
                <div className={`w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center font-heading font-bold text-sm flex-shrink-0 ${
                  item.rank === 1 ? 'bg-accent-500 text-white' :
                  item.rank === 2 ? 'bg-primary-500 text-white' :
                  item.rank === 3 ? 'bg-secondary-500 text-white' :
                  'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap mb-0.5">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                      {item.title}
                    </h3>
                    <span className="text-[10px] text-foreground-400 bg-background-200 px-1.5 py-0.5 rounded whitespace-nowrap">
                      {item.type}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 whitespace-nowrap">{item.hot}</p>
                </div>

                {/* Trend */}
                <div className={`flex items-center gap-1 text-xs font-medium flex-shrink-0 whitespace-nowrap ${
                  item.trend === 'up' ? 'text-accent-600' :
                  item.trend === 'stay' ? 'text-foreground-400' :
                  'text-foreground-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-sm"></i>}
                  {item.trend === 'stay' && <i className="ri-subtract-line text-sm"></i>}
                  <span>{item.change}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* #features - 3 feature cards */}
      <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50 scroll-mt-16">
        <div className="max-w-[1440px] mx-auto">
          <div className="text-center mb-8 md:mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
              核心优势
            </span>
            <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-900 mb-2">
              平台优势
            </h2>
            <p className="text-sm text-foreground-500 max-w-lg mx-auto">
              春夜影院致力于提供极致的免费影视在线观看体验
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-4xl mx-auto">
            {featureItems.map((item) => (
              <article
                key={item.id}
                className="group bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-7 text-center hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors duration-200">
                  <i className={`${item.icon} text-2xl md:text-3xl text-primary-600`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2.5">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}